export default __webpack_public_path__ + "static/media/q22022.e48f7ab2.png";